import React, { useContext, useState } from 'react';
import { UserContext } from 'contexts/UserContext';
import { makeStyles } from '@material-ui/core/styles';
import NearbyTrailLink from './NearbyTrailLink';
import RenameAlert from './RenameAlert';
import TripNotesModal from './TripNotesModal';
import Chip from '@material-ui/core/Chip';
import DeleteTripAlert from './DeleteTripAlert';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Card from '@material-ui/core/Card';
import CreateIcon from '@material-ui/icons/Create';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import NoImage from 'assets/icons/trailcard/triphistory/NoTripImage.png';
import { loadModules } from 'esri-loader';


const useStyles = makeStyles({
  root: {
    display: 'flex',
    border: 'none',
    boxShadow: 'none'
  },
  media: {
    height: 150,
    backgroundSize: 'cover',
    backgroundBlendMode: 'screen',
    filter:'brightness(70%)',
  },
  overlayTrail: {
    width: '26vw',
    color: 'white',
    fontFamily: 'Montserrat',
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '0.25px',
    overflow: 'hidden',
    whiteSpace: 'break-spaces',
  },
  overlayManageArea: {
    color: 'white',
    fontFamily: 'Open Sans',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoFlex: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '85px',
    left: '10px',
    right: '5px',
  },
  flexBox: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#4D4D4D',
  },
  nearbyTrailsFlex: {
    fontFamily: 'Open Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '17px',
    letterSpacing: '0.25px',
    textAlign: 'left',
  },
  favoriteAndDirectionsFlex: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#4D4D4D',
    height: '32px',
    marginBottom: '10px',
    marginTop: '8px',
  },
  distance: {
    fontWeight: '600',
    lineHeight: '20px',
    fontSize: '14px',
    letterSpacing: '0.25px',
    /* identical to box height, or 143% */
  },
  distanceSpeedFlex: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '5px',
  },
  trailConfiguration: {
    fontWeight: '300',
    lineHeight: '20px',
    fontSize: '14px',
    letterSpacing: '0.25px',
  },
  difficulty: {
    fontFamily: 'Open Sans',
    background: '#D1E9CB',
    borderRadius: '16px',
    width: '54px',
    height: '24px',
    textAlign: 'center',
    marginLeft: '15px',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#222222',
  },
  fee: {
    fontWeight: '600',
    marginLeft: 'auto',
    marginRight: '10px',
  },
  iconFlex: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    marginTop: '12px',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#4D4D4D',
    gap: '10px',
    justifyContent: 'flex-start',
  },
  favIcon: {
    backgroundSize: 'contain',
    color: 'white',
    height: '18.5px',
    width: '20px',
    top: '13px',
    left:'13px',
    position: 'absolute',
  },
  imgFlex: {
    display: 'flex',
  },
  managerFlex: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#4D4D4D',
    marginTop: '10px',
  },
  managerAttr:{
    color: '#4D4D4D',
    fontFamily: 'Open Sans',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '16.8px',
    letterSpacing: '0.25px',
    marginTop: '4px',
  },
  websiteAttr:{
    marginTop: '10px',
    color: '#4D7343',
  },
  managerTitle: {
    color: '#4D4D4D',
    fontFamily: 'Open Sans',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '16.8px',
    letterSpacing: '0.25px',
  },
  distanceSurfaceFlex: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#4D4D4D',
    marginTop: '8px',
    justifyContent: 'space-between',
  },
  nearbyTrails: {
    color: '#4D4D4D',
    fontFamily: 'Open Sans',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '19.2px',
    letterSpacing: '0.25px',
    flexGrow: '1', 
    display: 'inline-flex',
    marginTop: '2rem',
  },
  noPointer: {
    cursor: 'default'
  },
  backArrow: {
    backgroundSize: 'contain',
    color: 'white',
    height: '24.5px',
    width: '28px',
    top: '13px',
    left:'13px',
    position: 'absolute',
    cursor: 'pointer'
  },
  cameraContainer: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.01)',
      boxShadow: '1px 1px 5px 0px #999',
    }
  },
  pencil: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.01)',
      boxShadow: '1px 1px 5px 0px #999',
    },
    marginLeft: '5px',
    fontSize: '14px',
  },
  photoInput: {
    display: 'none'
  },
  footerContainer: {
    display: 'flex',
    position: 'fixed',
    left: '0',
    bottom: '3px',
    justifyContent: 'center',
    width: '30%',
  },
  footer: {
    color: '#B52626',
    borderColor: '#B52626',
    width: '90%',
    height: '40px',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '25px',
    letterSpacing: '0.75px',
    textAlign: 'left',
    marginRight: '10px'
  },
  footerRoot: {
    borderRadius: '4px',
    backgroundColor: '#ffffff',
  },
  tripNotesFlex: {
    display: 'flex',
    margin: '10px 5px 5px 5px',
  },
  notesText: {
    overflowWrap: 'break-word',
  },
});

export default function TripHistoryDetails({ feature, attributes, setSidebarSelection, nearbyTrails }) {
  const classes = useStyles();
  const { userInfo } = useContext(UserContext);
  const [renameAlertOpen, setRenameAlert] = useState(false);
  const [deleteAlertOpen, setDeleteAlert] = useState(false);
  const [tripNotesOpen, setTripNotesDialog] = useState(false);
  const [trailImage, setTrailImage] = useState(attributes.TrailImage);
  const [tripName, setTripName] = useState(attributes.TripName);
  const [notes, setNotes] = useState(attributes.Notes);
  const hiddenPhotoInput = React.useRef(null);

  const goBackToTripList = () => {
    setSidebarSelection(['Recorded Trips']);
  };

  const getDateTime = () => {
    return new Date(attributes.StartDateTime).toLocaleString('default', { month: 'long', year: 'numeric', day: 'numeric' });
  };
  
  const getTime = (unixtime) => {
    let date = new Date(unixtime);

    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;

    return strTime;
  };

  const handlePhotoInputClick = event => {
    hiddenPhotoInput.current.click();
  };

  const handlePhotoInputChange =  (event) => {
    let file = event.target.files[0];

    (async () => {
      try{
        const [esriRequest, FeatureLayer, AttachmentQuery, QueryTask] = await loadModules([
          'esri/request',
          'esri/layers/FeatureLayer',
          'esri/tasks/support/AttachmentQuery',
          'esri/tasks/QueryTask',
          ]);
          //Send file to table
          let form = new FormData();
          form.set("attachment", file);
          form.append("f","json")
          const tripHistoryUrlLayer = new FeatureLayer({url: userInfo.tripHistoryUrl});

          //Add attachment
          tripHistoryUrlLayer.addAttachment(feature, form).then(function (result) {
            // Replace trip photo
            const tripDetailsImageId = result.objectId

            // Update record with attachment id
            feature.attributes.TripDetailsImageAttachmentId = tripDetailsImageId;

            let features = [feature]
            let updateRes = tripHistoryUrlLayer.applyEdits({
              updateFeatures: features
            });

            //Delete other attachments
            const query = new AttachmentQuery({
              where: `OBJECTID = ${attributes.OBJECTID}`, // query all features in the layer
              attachmentsWhere: "1=1" // attachment queries
            });
            // When resolved, returns a count of the features that satisfy the query.
            const queryTask = new QueryTask({
              url: userInfo.tripHistoryUrl
            });


            queryTask.executeAttachmentQuery(query).then(function(results){
              if(results && results[attributes.OBJECTID]){
                setTrailImage(results[attributes.OBJECTID][results[attributes.OBJECTID].length - 1].url );
                let deleteTripImagesIds = results[attributes.OBJECTID].filter(res => res.id !== tripDetailsImageId && res.name !== 'MapImage.jpg').map(res => res.id);
                tripHistoryUrlLayer.deleteAttachments(feature, deleteTripImagesIds);
              }
            });
          }).catch(e => {
            console.log(e)
          })
      }catch(e){
        alert('Error encountered while attempting to upload image');
      }
    })();

  };
  const handleRenameAlertClose = () => {
    setRenameAlert(false);
  };

  const handleRenameAlertOpen = () => {
    setRenameAlert(true);
  };

  const handleDeleteTripAlertOpen = () => {
    setDeleteAlert(true);
  };

  const handleDeleteTripAlertClose = () => {
    setDeleteAlert(false);
  };

  const handleTripNotesDialogOpen = () => {
    setTripNotesDialog(true);
  };

  const handleTripNotesDialogClose = () => {
    setTripNotesDialog(false);
  };

  const deleteTrip = async () => {
    const [esriRequest] = await loadModules(['esri/request']);
    const { removeAllGraphics } = await import('data/map');
    handleDeleteTripAlertClose();
    const objectIds = [attributes.OBJECTID];
    await esriRequest(userInfo.tripHistoryUrl + '/applyEdits',{
      method: 'post', // POST request
      query: {
          deletes: JSON.stringify(objectIds),
          f:"json" // format
      },
    }).then((r) => {
        setSidebarSelection(['Recorded Trips']);
        removeAllGraphics();
    }).catch((e) => {
        console.log(e);
        alert('Failed to delete, please try again');
    });
  };

  return (
    <Card className={classes.root}>
      <CardActionArea className={classes.noPointer}>
        <CardMedia
          className={classes.media}
          image={trailImage ? trailImage : NoImage}
          title="Trip History Details"
        />
        <div class={classes.imgFlex}>
          <ArrowBackIcon classes={{root: classes.backArrow}} onClick={() => {goBackToTripList()}}></ArrowBackIcon>
        </div>
        <div class={classes.infoFlex}>
            <div class={classes.overlayTrail}>   
              {tripName}
              <CreateIcon className={classes.pencil} onClick={handleRenameAlertOpen}/>
              <RenameAlert renameAlertOpen={renameAlertOpen} setRenameAlertClose={handleRenameAlertClose} feature={feature} userInfo={userInfo} setTripName={setTripName}/>
            </div>
            <div class={classes.overlayManageArea}>
              {getDateTime()}
              <div className={classes.cameraContainer} onClick={handlePhotoInputClick}>
                <input type="file" accept="image/*" onChange={handlePhotoInputChange} ref={hiddenPhotoInput} className={classes.photoInput}/>
                <CameraAltIcon />
              </div>
            </div>
        </div>
        <CardContent>
        <div class={classes.distanceSpeedFlex}>
            <div class={classes.managerFlex}>
                <div class={classes.managerTitle}>Length</div>
                <div class={classes.managerAttr}>{attributes.TotalDistance} mi</div>
            </div>
            <div class={classes.managerFlex}>
                <div class={classes.managerTitle}>Speed</div>
                <div class={classes.managerAttr}>{attributes.Speed} mph</div>
            </div>
        </div>
        <div class={classes.distanceSpeedFlex}>
            <div class={classes.managerFlex}>
                <div class={classes.managerTitle}>Total Time</div>
                <div class={classes.managerAttr}>{attributes.TotalTime}</div>
            </div>
            <div class={classes.managerFlex}>
                <div class={classes.managerTitle}>Start Time</div>
                <div class={classes.managerAttr}>{getTime(attributes.StartDateTime)}</div>
            </div>
            <div class={classes.managerFlex}>
                <div class={classes.managerTitle}>End Time</div>
                <div class={classes.managerAttr}>{getTime(attributes.EndDateTime)}</div>
            </div>
        </div>
        <div class={classes.tripNotesFlex}>
          <div class={classes.managerTitle}>Trip Notes</div>
          <CreateIcon className={classes.pencil} onClick={handleTripNotesDialogOpen}/>
          <TripNotesModal tripNotesOpen={tripNotesOpen} setTripNotesDialogClose={handleTripNotesDialogClose} feature={feature} userInfo={userInfo} notes={notes} setNotes={setNotes}/>
        </div>
        {
          notes? 
          <div class={classes.notesText}><br />{notes}<br /><br /><br /> <br /> <br /></div>
          : null
        }
        
        {nearbyTrails && nearbyTrails.length ? 
        (
        <div>
            <div class={classes.nearbyTrails}>Neighboring Trails</div>
            <ul>
            {nearbyTrails.map(trail => 
                {return <NearbyTrailLink attributes={trail.attributes} setSidebarSelection={setSidebarSelection}/>})}
            </ul>
        </div>
        )
            : null}
        <div class={classes.footerContainer} onClick={handleDeleteTripAlertOpen}>
          <Chip variant="outlined" size="small" label="DELETE TRIP" clickable className={classes.footer} classes={{root: classes.footerRoot}}/>
        </div>
        <DeleteTripAlert deleteAlertOpen={deleteAlertOpen} setDeleteTripAlertClose={handleDeleteTripAlertClose} deleteTrip={deleteTrip}/>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
